<!--
 * @Description: Description
 * @Author: zhaoqianqian
 * @Date: 2021-10-29 14:02:22
 * @LastEditors: liyunfei 3090384495@qq.com
 * @LastEditTime: 2025-10-23 16:43:07
-->
<template>
    <div :class="['setting-user', $i18n.locale]">
        <div class="header-menu">
            <span>
                <img
                    src="@/assets/images/sidebar/arrow-left.png"
                    alt
                    class="menu-info"
                    @click.prevent="onClickLeft()"
                />
            </span>
        </div>
        <div class="content">
            <div class="title">{{ $t('sidebar.accountSecurity') }}</div>
            <div class="content-view">
                <div class="item-view">
                    <div class="item">
                        <div class="left">
                            {{ mobile ? $t('sidebar.form.labelList[0]') : $t('login.email') }}
                        </div>
                        <div class="right">
                            <div class="title" style="width: 250px">
                                {{ iphone || email }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-view">
                <div class="item-view" v-for="(item, index) in cellList" :key="index">
                    <div class="item">
                        <div class="left">
                            {{ item.label }}
                        </div>
                        <div class="right" @click="itemClick(item)">
                            <div class="title">
                                {{ item.value ? item.value.nickname : item.title }}
                            </div>
                            <div class="image-view">
                                <img class="image" src="../../../assets/images/sidebar/account-icon.png" alt="" />
                            </div>
                        </div>
                    </div>
                    <div v-if="index != cellList.length - 1" class="line"></div>
                </div>
            </div>

            <van-dialog v-model="isConfirm" :show-confirm-button="false">
                <template slot="title"> {{ $t('login.accountSecurity.dialogTitle') }} </template>
                <p style="margin-top: 16px">{{ confirmDesc }}</p>
                <div class="btns">
                    <div class="warrper1">
                        <van-button plain @click="onCancel" class="dialog-cancel">{{
                            $t('sidebar.btn.cancelBtn')
                        }}</van-button>
                    </div>
                    <div class="warrper2">
                        <van-button @click="onConfirm" class="dialog-confirm">{{
                            $t('sidebar.btn.confirmBtn')
                        }}</van-button>
                    </div>
                </div>
            </van-dialog>
        </div>
        <div v-if="loading" class="loading-overlay">
            <van-loading :size="50" type="circular" color="rgb(100, 100, 100)" />
        </div>
    </div>
</template>

<script>
import {
    findCurrentMember,
    getThirdLoginUrl,
    bindOldMember,
    thirdLogin,
    unbindThirdAccount,
} from '@/assets/js/apolloGql.js'
import { parseAuthCallback } from '@/assets/js/util.js'
import { faceBookLogin, googleLogin } from '@/assets/js/config.js'

export default {
    data() {
        return {
            cellList: [], // 改为 data 属性
            iphone: '',
            mobile: '',
            email: window.localStorage.getItem('email'),
            memberInfo: null,
            isConfirm: false,
            confirmDesc: '',
            unbindValue: null,
            loading: false, // 第三方登录loading
            loadingTimer: null,
        }
    },
    created() {
        const url = window.location.href
        const data = parseAuthCallback(url)
        if (data && data.state && data.accessToken) {
            if (data.state.scan_id) {
                this.findScanTypeInfoheightByScanId(data.state.scan_id)
            }
            this.loading = true
            this.thirdLogin(data.state.type, data.accessToken)
        }
    },
    computed: {
        baseCellList() {
            const arr = [
                {
                    label: this.$t('sidebar.setPassword'),
                    value: '',
                    type: 0,
                    title: '',
                },
            ]
            if (googleLogin === 'true') {
                arr.push({
                    label: this.$t('login.accountSecurity.google'),
                    value: null,
                    type: 1,
                    title: this.$t('login.accountSecurity.isBind'),
                })
            }
            if (faceBookLogin === 'true') {
                arr.push({
                    label: this.$t('login.accountSecurity.faceBook'),
                    value: null,
                    type: 2,
                    title: this.$t('login.accountSecurity.isBind'),
                })
            }

            return arr
        },
    },
    mounted() {
        console.log(window.localStorage.getItem('email'))
        this.initCellList() 
        this.findCurrentMember()
        window.addEventListener('popstate', () => {
            // 在这里处理返回按钮事件
            console.log('返回按钮被点击')
            this.loading = true
        })
    },
    beforeDestroy() {
        window.clearTimeout(this.loadingTimer)
    },
    methods: {
        initCellList() {
            this.cellList = JSON.parse(JSON.stringify(this.baseCellList))
        },
        onCancel() {
            this.isConfirm = false
        },
        onConfirm() {
            // 解绑
            if (this.unbindValue && this.unbindValue.value) {
                this.unbindThirdAccount(this.unbindValue.value)
            }
            this.isConfirm = false
        },
        fomatterIphone(str) {
            let result = str || ''
            const phoneLen = result.length
            if (phoneLen > 14) {
                result = result.substr(0, 7) + '****' + result.substr(phoneLen - 4)
            } else if (phoneLen === 14) {
                result = result.substr(0, 6) + '****' + result.substr(phoneLen - 4)
            } else if (phoneLen > 7) {
                result = result.substr(0, 5) + '*'.repeat(phoneLen - 7) + result.substr(phoneLen - 2)
            }
            return result
        },
        onClickLeft() {
            this.$router.push({
                name: 'report',
                params: { type: 1 },
            })
        },
        // 侧边栏 获取用户信息
        findCurrentMember() {
            this.$apollo
                .query({
                    query: findCurrentMember,
                    fetchPolicy: 'network-only',
                })
                .then((res) => {
                    const data = res.data.findCurrentMember
                    if (data && data.code === 200) {
                        this.iphone = this.fomatterIphone(data.data.mobile)
                        this.mobile = data.data.mobile
                        this.memberInfo = data.data
                        if (data.data.thirdAccount) {
                            this.cellList.forEach((cell) => {
                                let value = null
                                data.data.thirdAccount.forEach((item) => {
                                    if (cell.type === item.type) {
                                        value = item
                                    }
                                })
                                cell.value = value
                            })
                        }
                        console.log(this.cellList)
                    }
                })
        },
        itemClick(item) {
            console.log(item)
            switch (item.type) {
                case 0:
                    {
                        //设置密码
                        this.$router.push({
                            path: '/setPassword',
                            query: { type: 'setPassword' },
                        })
                    }
                    break
                case 1:
                case 2:
                    {
                        // 谷歌账号
                        if (item.value) {
                            if (item.value.isRegister === 1) {
                                this.$toast({
                                    message: this.$t('login.bindError[8]', { item: '' }),
                                    duration: 2000,
                                    className: 'success-toast',
                                })
                            } else {
                                // 解绑
                                if (item.type === 1) {
                                    this.confirmDesc = this.$t('login.accountSecurity.dialogCenter', { item: 'Google' })
                                } else {
                                    this.confirmDesc = this.$t('login.accountSecurity.dialogCenter', {
                                        item: 'Facebook',
                                    })
                                }
                                this.unbindValue = item
                                this.isConfirm = true
                            }
                        } else {
                            // 绑定
                            this.bindThirdAccount(item.type)
                        }
                    }
                    break
                default: {
                    console.log('_ _')
                }
            }
        },
        // 绑定第三方账号
        bindThirdAccount(type) {
            if (type === 1 || type === 2) {
                this.loading = true
                this.loadingTimer = setTimeout(() => {
                    this.loading = false
                    window.clearTimeout(this.loadingTimer)
                }, 1000 * 30)
                // 谷歌
                this.$apollo
                    .query({
                        query: getThirdLoginUrl,
                        fetchPolicy: 'network-only',
                        variables: {
                            type: `${type}`,
                            uri: 'accountSecurity'
                        },
                    })
                    .then((res) => {
                        const data = res.data.getThirdLoginUrl
                        if (data && data.code === 200) {
                            const params = {
                                query: this.$route.query || '/exception/report',
                                type: `${type}`,
                                userId: this.userId,
                            }
                            const state = Buffer.from(JSON.stringify(params)).toString('base64')
                            const url = `${data.data}&state=${encodeURIComponent(state)}`
                            console.log(`=======>url: ${url}`)
                            window.location.href = url
                        }
                    })
                    .catch(() => {
                        this.loading = false
                        console.log('获取第三方登录链接')
                    })
            }
        },
        // 解绑第三方账号
        unbindThirdAccount(account) {
            console.log(account)
            this.$apollo
                .query({
                    query: unbindThirdAccount,
                    fetchPolicy: 'network-only',
                    variables: {
                        code: account.code,
                        type: account.type,
                        memberId: account.memberId,
                    },
                })
                .then((res) => {
                    const data = res.data.unbindThirdAccount
                    if (data && data.code === 200) {
                        // 解绑成功
                        this.$toast({
                            message: this.$t('login.bindError[1]'),
                            duration: 2000,
                            className: 'success-toast',
                        })
                        this.findCurrentMember() // 刷新数据
                    } else {
                        // 解绑失败
                        this.$toast({
                            message: this.$t('login.bindError[2]'),
                            duration: 2000,
                            className: 'success-toast',
                        })
                    }
                })
                .catch(() => {
                    console.log('解绑失败')
                    this.$toast({
                        message: this.$t('login.bindError[2]'),
                        duration: 2000,
                        className: 'success-toast',
                    })
                })
        },
        thirdLogin(type, token) {
            if (type === '1' || type === '2') {
                // 谷歌
                this.$apollo
                    .query({
                        query: thirdLogin,
                        fetchPolicy: 'network-only',
                        variables: {
                            type: `${type}`,
                            token: token,
                        },
                    })
                    .then((res) => {
                        const data = res.data.thirdLogin
                        this.loading = false
                        if (data && data.code === 200) {
                            console.log(data)

                            if (data.data && !data.data.token) {
                                // 新的第三方账号可以绑定老用户
                                console.log(data.data)
                                this.bind(data.data)
                            } else if (data.data && data.data.token && data.data.email === this.email) {
                                // 如果第三方张号的邮箱和member的邮箱相同登录时就自动绑定了
                                this.$toast({
                                    message: this.$t('login.bindError[5]'),
                                    duration: 2000,
                                    className: 'success-toast',
                                })
                                this.findCurrentMember() // 刷新数据
                            } else {
                                // 绑定过其他用户了
                                this.$router.push({
                                    path: '/bindFailed',
                                    query: {
                                        type: data.data.type,
                                        email: data.data.email,
                                        phone: data.data.mobile,
                                    },
                                })
                            }
                        } else {
                            // 绑定失败
                            this.$toast({
                                message: this.$t('login.bindError[0]'),
                                duration: 2000,
                                className: 'success-toast',
                            })
                        }
                    })
                    .catch((e) => {
                        this.loading = false
                        console.log(`验证第三方账号是否存在: ${e}`)
                    })
            }
        },
        bind(data) {
            this.$apollo
                .mutate({
                    mutation: bindOldMember,
                    variables: {
                        thirdMember: {
                            mobile: this.memberInfo.mobile,
                            email: this.memberInfo.email,
                            password: null,
                            smsCode: null,
                            nickname: data.nickname,
                            picture: data.picture,
                            code: data.code,
                            identifier: data.identifier,
                            type: data.type,
                        },
                    },
                })
                .then((res) => {
                    const data = res.data.bindOldMember
                    console.log(data)
                    this.$toast({
                        message: this.$t('login.bindError[5]'),
                        duration: 2000,
                        className: 'success-toast',
                    })
                    this.findCurrentMember() // 刷新数据
                })
                .catch(() => {
                    this.loginBtnState = false
                })
        },
    },
}
</script>

<style lang="less" scoped>
.setting-user {
    width: 100%;
    height: 100%;
    background-color: #222341;
    text-align: left;
    overflow: scroll;

    .loading-overlay {
        position: fixed; /* 覆盖整个视口 */
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.5); /* 可选：半透明遮罩 */
        z-index: 1000; /* 确保在最上层 */
    }

    .header-menu {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 15px;
        width: 100%;
        top: 0;
        z-index: 100;
        > span {
            img {
                display: block;
            }
        }
        .menu-info {
            width: 24px;
            height: 24px;
        }
    }
    .content {
        padding: 0 15px;
        .title {
            padding-left: 16px;
            padding-top: 16px;
            padding-bottom: 12px;
            color: #8f909e;
        }
        .content-view {
            background-color: #303c5c;
            border-radius: 4px;
            margin-bottom: 10px;
            padding: 0 15px 0 15px;
            .item-view {
                display: flex;
                flex-direction: column;
                .item {
                    display: flex;
                    width: 100%;
                    height: 44px;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    .left {
                        width: 120px;
                        font-size: 13px;
                        color: #fff;
                    }
                    .right {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        .title {
                            width: 150px;
                            font-size: 13px;
                            color: rgba(255, 255, 255, 0.5);
                            line-height: 16px;
                            text-align: right;
                            /* 新增的多行省略样式 */
                            display: -webkit-box;
                            -webkit-line-clamp: 2; /* 限制显示两行 */
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                        .image-view {
                            margin-right: 8xp;
                            margin-top: 5px;
                            .image {
                                width: 16px;
                                height: 16px;
                            }
                        }
                    }
                }
                .line {
                    width: 100%;
                    height: 1px;
                    background-color: rgba(255, 255, 255, 0.1);
                }
            }
        }

        /deep/ .van-dialog {
            width: 290px;
            background-color: #e7e7e7;
            padding: 20px;
            padding-top: 0;
            p {
                margin-bottom: 15px;
                text-align: center;
                font-size: 14px;
                margin: 0 10 px;
            }
            .btns {
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;
                .dialog-cancel {
                    width: 112px;
                    height: 32px;
                    position: relative;
                    border-radius: 5px;
                    border: none;
                    color: #000;
                    margin-right: 15px;
                    background: #e7e7e7;

                    /* 使用阴影模拟边框 */
                    box-shadow: inset 0 0 0 1px rgba(0, 227, 201, 0.3), inset 0 0 0 1px rgba(0, 159, 232, 0.7);

                    /* 或者使用背景裁剪 */
                    background-clip: padding-box;
                    border: 1px solid transparent;
                    background-image: linear-gradient(#e7e7e7, #e7e7e7),
                        linear-gradient(90deg, rgba(0, 227, 201, 1), rgba(0, 159, 232, 1));
                }
                .dialog-confirm {
                    color: #000;
                    width: 112px;
                    height: 30px;
                    background: linear-gradient(90deg, #00e3c9 0%, #009fe8 100%);
                    border-radius: 5px !important;
                    border: 1px solid transparent;
                    // border-image: linear-gradient(90deg, rgba(0, 227, 201, 1), rgba(0, 159, 232, 1)) 1 1;
                }
            }
        }

    }
}

.ar-AR {
    .header-menu {
        span .menu-info {
            position: relative;
            left: 320px;
        }
    }
    .content {
        direction: rtl;
        padding: 0 15px;
        .title {
            padding-left: 16px;
            padding-top: 16px;
            padding-bottom: 12px;
            color: #8f909e;
            text-align: right;
        }
        .content-view {
            background-color: #303c5c;
            border-radius: 4px;
            margin-bottom: 10px;
            padding: 0 15px 0 15px;
            .item-view {
                display: flex;
                flex-direction: column;
                .item {
                    display: flex;
                    width: 100%;
                    height: 44px;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    .left {
                        width: 120px;
                        font-size: 13px;
                        color: #fff;
                        text-align: right;
                    }
                    .right {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        .title {
                            width: 150px;
                            font-size: 13px;
                            color: rgba(255, 255, 255, 0.5);
                            line-height: 16px;
                            text-align: left;
                        }
                        .image-view {
                            margin-right: 8xp;
                            margin-top: 3px;
                            .image {
                                width: 16px;
                                height: 16px;
                                transform: scaleX(-1); /* 水平翻转图片 */
                            }
                        }
                    }
                }
                .line {
                    width: 100%;
                    height: 1px;
                    background-color: rgba(255, 255, 255, 0.1);
                }
            }

            .dialog-cancel {
                width: 72px !important;
                margin-right: 0 !important;
            }
            .van-dialog p {
                text-align: right;
            }
        }
    }
}
.ro-RO {
    .content .item-view .item .left {
        width: 220px !important;
    }
}
.pl-PL {
    .content .item-view .item .left {
        width: 140px !important;
        white-space: nowrap;
    }
}
</style> 
